import { render, staticRenderFns } from "./AppSider.vue?vue&type=template&id=c16b7d2c"
import script from "./AppSider.vue?vue&type=script&lang=js"
export * from "./AppSider.vue?vue&type=script&lang=js"
import style0 from "./AppSider.vue?vue&type=style&index=0&id=c16b7d2c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports